import cx from 'classnames';
import { CopyText, SvgIcon } from '@/components';
import { getIconByNetwork, getShortHash } from '@/helpers';
import { TraceEntry } from '../TraceInvestigationForm/TraceInvestigationForm.types';

import styles from './TraceEntryChip.module.sass';

interface TraceEntryChipProps {
  entry: TraceEntry;
  onEdit: () => void;
  onRemove: () => void;
}

const TraceEntryChip = ({
  entry,
  onEdit,
  onRemove,
}: TraceEntryChipProps): JSX.Element => {
  return (
    <div className={styles.chip}>
      <img
        src={getIconByNetwork(entry.chain)}
        alt={entry.chain}
        className={styles.icon}
      />
      <div className={styles.info}>
        <div className={styles.hash}>
          <CopyText
            text={getShortHash(entry.hash)}
            copyText={entry.hash}
            className={styles.hashCopy}
          />
        </div>
        <div className={styles.meta}>
          <span className={styles.network}>{entry.networkName}</span>
          <span className={styles.asset}>{entry.displayAsset}</span>
        </div>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.actionBtn}
          onClick={onEdit}
          aria-label="Edit"
        >
          <SvgIcon name="pencil" />
        </button>
        <button
          type="button"
          className={cx(styles.actionBtn, styles.actionBtnDanger)}
          onClick={onRemove}
          aria-label="Remove"
        >
          <SvgIcon name="close" />
        </button>
      </div>
    </div>
  );
};

export default TraceEntryChip;
